import {APIRequest} from "./APIRequest.js";

export async function saveAppState(view, params = null) {
	var request = new APIRequest();
	request.set('saveAppState', 'view', view);
	request.set('saveAppState', 'params', params ? JSON.stringify(params) : "");
	await request.send();
}